<div class="dashBoardOuterDiv" [style.background-color]="backgroundColorHomePage">
  <div class="dashBoardInnerOuterDiv customInnerOuterDiv" style="margin-top:3%">
  

    <mat-tab-group class="homeTab">
      <ng-container *ngFor="let permissionsObj of permissionsParentChild; let index = index">
  <mat-tab [label]="permissionsObj.screenName">
    <div *ngIf="permissionsObj.child.length>0">
      <div *ngFor="let children of permissionsObj.child">
        <div class="row rowCustom" *ngIf="permissionsObj.screenName == 'JSIP'">
          <div *ngFor="let childrenObj of children">
          <div *ngIf="childrenObj.screenName == 'Signal Management'" class="col	col-sm-6	col-lg-2	col-xl-2"  title={{childrenObj.screenName}} style="padding: 0;">
            <a [routerLink]="['/user/Dynamic/dynamic']" [queryParams]="{screenType:childrenObj.screenType,tableName:'jsip-Summary',headerNameHtml:childrenObj.screenName}" class="blockDiv">
            <div class="blockInnerDiv">
         <div class="blockImageDiv" >
          <img class="blockImage" [src]="getSanitizer('data:image/svg+xml;base64,'+childrenObj.screenImage)" alt="" >
        </div>
        <div class="blockTextDiv">{{childrenObj.screenName}}</div> 
            </div>
               
          </a>
          </div>
          </div>
        </div>

          <div class="row rowCustom" *ngIf="permissionsObj.screenName != 'JSIP' && permissionsObj.screenName != 'Jaivik'">
          <div class="col	col-sm-6	col-lg-2	col-xl-2" *ngFor="let childrenObj of children" title={{childrenObj.screenName}} style="padding: 0;">
            <a [routerLink]="['/user/Dynamic/dynamic']" [queryParams]="{screenType:childrenObj.screenType,tableName:childrenObj.urlPath,headerNameHtml:childrenObj.screenName}" class="blockDiv">
            <div class="blockInnerDiv">
         <div class="blockImageDiv" >
          <img class="blockImage" [src]="getSanitizer('data:image/svg+xml;base64,'+childrenObj.screenImage)" alt="" >
        </div>
        <div class="blockTextDiv">{{childrenObj.screenName}}</div> 
            </div>
               
          </a>
          </div>
        </div>
        <div class="row rowCustom" *ngIf="permissionsObj.screenName == 'Jaivik'">
          <div *ngFor="let childrenObj of children">
            <div *ngIf="childrenObj.screenName == 'Jaivik Dashboard'" class="col	col-sm-6	col-lg-2	col-xl-2"
              title={{childrenObj.screenName}} style="padding: 0;">
              <a [routerLink]="['/user/jaivik-app']" [queryParams]="{tableName:'dashboard'}" class="blockDiv">
                <div class="blockInnerDiv">
                  <div class="blockImageDiv">
                    <img class="blockImage" [src]="getSanitizer('data:image/svg+xml;base64,'+childrenObj.screenImage)" alt="">
                  </div>
                  <div class="blockTextDiv">{{childrenObj.screenName}}</div>
                </div>
        
              </a>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </mat-tab>
      </ng-container>
      </mat-tab-group>

  </div>
</div>